import ConnectedStatus from './ConnectedStatus';
import Status from './Status';

export { Status };
export default ConnectedStatus;
